module.exports = __webpack_public_path__ + "img/gb820.prt.786d2dfe.jpg";